/**
 * SeasonDropdown Selectors
 */
import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

// Selectors
import { selectSeasons } from '../../services/seasons/selectors';
import { selectCurrentOrganizationId } from '../../services/currentOrganizationId/selectors';

// Utils
import orderBy from '../../utils/custom-orderBy';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

const selectData = createDeepEqualSelector(
    selectSeasons,
    seasonsState => seasonsState && Object.values(seasonsState)
);

const selectFilteredData = createDeepEqualSelector(
    [selectData, selectCurrentOrganizationId],
    (dataState, currentOrganizationIdState) =>
        dataState.filter(
            value => value.organizationId === currentOrganizationIdState
        )
);

const selectOrderedData = createDeepEqualSelector(
    selectFilteredData,
    filteredDataState => orderBy(filteredDataState, 'name')
);

const selectOptions = createDeepEqualSelector(
    selectOrderedData,
    orderedDataState =>
        orderedDataState.map(({ id, name }) => ({
            key: id,
            text: name.replace(' Season', ''),
            value: id
        }))
);

export { selectOptions };
